import { useState } from "react";
import { Star, Tag } from "lucide-react";

export const INTENTS = [
  { id: "daily", label: "Daily", pile: "dailies" },
  { id: "keep", label: "Keep", pile: "keepers" },
  { id: "sentimental", label: "Sentimental", pile: "keepers" },
  { id: "sell", label: "Sell", pile: "sell" },
  { id: "too_small", label: "Too small", pile: "sell" },
  { id: "dont_like", label: "Don't like", pile: "sell" },
];
export const intentLabel = (id) => INTENTS.find((i) => i.id === id)?.label;
export const isSellIntent = (id) => ["sell", "too_small", "dont_like"].includes(id);

/** 1-5 stars. Zero stars = the Sell shortcut (per product notes). */
export const StarRating = ({ value, onChange, size = "h-5 w-5", showSell = true, testid = "stars" }) => {
  const [hover, setHover] = useState(0);
  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" onClick={() => onChange(n)} onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)}
          className="p-0.5 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" aria-label={`${n} star${n > 1 ? "s" : ""}`} data-testid={`${testid}-${n}`}>
          <Star className={`${size} transition-colors ${(hover || value || 0) >= n ? "fill-gold text-gold-deep" : "text-border"}`} />
        </button>
      ))}
      {showSell && (
        <button type="button" onClick={() => onChange(0)} className={`ml-1.5 inline-flex items-center gap-1 rounded-full px-2.5 h-7 text-[11px] font-medium border transition-colors ${value === 0 ? "bg-foreground text-background border-foreground" : "border-border text-muted-foreground hover:text-foreground"}`} data-testid={`${testid}-sell`}>
          <Tag className="h-3 w-3" /> Sell
        </button>
      )}
    </div>
  );
};

/** Keep / sell triage chips. When a sell-type chip is picked the reason IS the chip (don't like / too small / sell). */
export const IntentChips = ({ value, onChange, compact = false, testid = "intent" }) => (
  <div className="flex flex-wrap gap-1.5" data-testid={testid}>
    {INTENTS.map((i) => (
      <button key={i.id} type="button" onClick={() => onChange(i.id)}
        className={`rounded-full border px-2.5 ${compact ? "h-7 text-[11px]" : "h-8 text-xs"} font-medium transition-colors ${value === i.id ? (i.pile === "sell" ? "bg-foreground text-background border-foreground" : "bg-secondary border-foreground/30 text-foreground") : "border-border text-muted-foreground hover:text-foreground"}`}
        data-testid={`${testid}-${i.id}`}>{i.label}</button>
    ))}
  </div>
);

export const PileBadge = ({ intent }) => {
  if (!intent) return null;
  const i = INTENTS.find((x) => x.id === intent);
  if (!i) return null;
  const cls = i.pile === "sell" ? "bg-foreground text-background" : i.pile === "dailies" ? "bg-good/15 text-good" : "bg-secondary text-foreground";
  return <span className={`inline-flex items-center rounded-full px-2 h-5 text-[10px] font-medium ${cls}`} data-testid="pile-badge">{i.label}</span>;
};

export const Stars = ({ n, className = "" }) => n ? (
  <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${n} of 5 stars`}>
    {[1, 2, 3, 4, 5].map((k) => <Star key={k} className={`h-3 w-3 ${k <= n ? "fill-gold text-gold-deep" : "text-border"}`} />)}
  </span>
) : null;
